import React, { useEffect, useState, createContext, useContext } from 'react';
export type Lang = 'en' | 'es';
const translations = {
  en: {
    // Nav
    'nav.about': 'About',
    'nav.practice': 'Practice Areas',
    'nav.results': 'Results',
    'nav.cta': 'Free Consultation',
    // Splash
    'splash.loading': 'LOADING ELITE REPRESENTATION',
    // Hero
    'hero.badge': 'Accepting New Clients · Florida',
    'hero.tagline': 'Elias Navarro Law',
    'hero.headline.1': "Don't Let Insurance",
    'hero.headline.2': 'Companies Control',
    'hero.headline.3': 'Your Future.',
    'hero.subheadline': 'Luxury-level legal representation for serious accident and injury cases across Florida. Built for high-stakes results.',
    'hero.btn.primary': 'Free Case Review',
    'hero.btn.secondary': 'Speak With Elias Now',
    'hero.scroll': 'Scroll',
    // Hero Form
    'hero.form.label': 'Free Case Review · Confidential',
    'hero.form.name': 'Full Name',
    'hero.form.phone': 'Phone Number',
    'hero.form.case': 'Type of Case',
    'hero.form.case.placeholder': 'Select case type',
    'hero.form.case.auto': 'Car Accident',
    'hero.form.case.truck': 'Truck Accident',
    'hero.form.case.slip': 'Slip & Fall',
    'hero.form.case.motorcycle': 'Motorcycle Accident',
    'hero.form.case.other': 'Other Injury',
    'hero.form.submit': 'Get My Free Review',
    'hero.form.submitting': 'Sending...',
    'hero.form.disclaimer': 'No fees unless we win · 100% confidential · 24/7',
    'hero.form.success.title': 'Request received.',
    'hero.form.success.body': 'Elias will personally review your case and contact you within the hour.',
    // Trust
    'trust.recovered': 'Recovered for Clients',
    'trust.clients': 'Clients Represented',
    'trust.available': 'Always Available',
    'trust.fee': 'Fee Unless We Win',
    // About
    'about.label': 'About the Firm',
    'about.headline': 'Built For<br />High-Stakes Cases.',
    'about.body': 'Elias Navarro Law was created to provide elite legal representation for accident victims facing powerful insurance companies. After years working alongside major corporate firms in Miami, Elias Navarro built a modern law firm focused on aggressive strategy and personal attention.',
    'about.list.1': 'Aggressive negotiation with insurance corporations',
    'about.list.2': 'Fast, direct communication with your attorney',
    'about.list.3': 'Personalized legal strategy for every case',
    'about.list.4': 'Premium representation across all of Florida',
    'about.list.5': 'Results-driven approach for modern clients',
    'about.tag.years': '18',
    'about.tag.text': 'Years Elite Practice',
    // Practice Areas
    'practice.label': 'What We Handle',
    'practice.headline': 'Practice Areas',
    'practice.1.title': 'Car Accidents',
    'practice.1.desc': 'Maximum compensation for collision victims. We fight every insurance dispute head-on.',
    'practice.2.title': 'Truck Accidents',
    'practice.2.desc': 'High-value claims against commercial carriers and their powerful legal teams.',
    'practice.3.title': 'Wrongful Death',
    'practice.3.desc': 'Compassionate, aggressive representation for families who deserve justice and closure.',
    'practice.4.title': 'Slip & Fall',
    'practice.4.desc': 'Premises liability cases handled with precision, speed, and relentless advocacy.',
    'practice.5.title': 'Motorcycle Accidents',
    'practice.5.desc': 'Riders deserve elite legal protection. We know how to win these cases.',
    'practice.6.title': 'Insurance Disputes',
    'practice.6.desc': "We don't settle for low offers. We force insurance companies to pay what you deserve.",
    'practice.learnMore': 'Learn More →',
    // Video
    'video.label': 'Our Approach',
    'video.headline': 'Modern Legal Representation.',
    'video.body': "Watch how Elias Navarro Law fights for injury victims across Florida — and why our approach produces results that other firms can't match.",
    'video.tag': 'Elias Navarro Law · Client Stories',
    // Testimonials
    'test.label': 'Client Results',
    'test.headline': 'What Our Clients Say.',
    'test.1.quote': "They treated my case like it actually mattered. The communication and professionalism were next level. I've never felt more represented.",
    'test.1.author': 'M. Rivera · Car Accident · Miami, FL',
    'test.2.quote': "I almost accepted the insurance company's first offer. Elias Navarro Law changed everything. We settled for 8x the original amount.",
    'test.2.author': 'J. Delgado · Truck Accident · Orlando, FL',
    'test.3.quote': "Fast responses. Serious representation. Incredible outcome. If you're hurt and need a real attorney, this is the only call you need to make.",
    'test.3.author': 'A. Morales · Slip & Fall · Tampa, FL',
    // Final CTA
    'cta.label': 'Take The First Step',
    'cta.headline': 'Your case deserves more.',
    'cta.subheadline': 'Speak directly with Elias Navarro today.<br />No pressure. No fees unless we win. Just elite legal strategy.',
    'cta.btn.primary': 'Start Your Claim',
    'cta.btn.secondary': 'Free Consultation',
    // Footer
    'footer.copy': '© 2025 Elias Navarro Law. All Rights Reserved.',
    'footer.disclaimer': 'Attorney Advertising. Prior results do not guarantee similar outcomes. This website is for informational purposes only and does not constitute legal advice.',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms',
    'footer.contact': 'Contact',
    // Legal Modals
    'legal.privacy.title': 'Privacy Policy',
    'legal.privacy.p1': 'Elias Navarro Law respects your privacy and is committed to protecting your personal information. This policy explains what information we collect, how we use it, and the choices you have.',
    'legal.privacy.p2': 'We collect information you provide directly when contacting us for a consultation, including your name, phone number, email address, and details about your case. This information is used solely to evaluate and respond to your inquiry.',
    'legal.privacy.p3': 'We do not sell, rent, or share your personal information with third parties for marketing purposes. Information may be shared with our staff, retained experts, or co-counsel strictly as required to evaluate or pursue your matter.',
    'legal.privacy.p4': 'Our website may use cookies and analytics tools to understand how visitors interact with our site. You can disable cookies in your browser settings at any time.',
    'legal.privacy.p5': 'You may request access to, correction of, or deletion of your personal information at any time by contacting our office. We retain consultation records only as long as legally necessary.',
    'legal.terms.title': 'Terms of Use',
    'legal.terms.p1': 'By accessing or using this website, you agree to these Terms of Use. If you do not agree, please do not use the site.',
    'legal.terms.p2': 'The content on this website is for general informational purposes only and does not constitute legal advice. No attorney-client relationship is created by visiting this site, submitting a contact form, or sending an email.',
    'legal.terms.p3': 'An attorney-client relationship is formed only upon execution of a written engagement agreement signed by Elias Navarro Law and the client.',
    'legal.terms.p4': 'Prior case results, settlements, and verdicts referenced on this site do not guarantee or predict similar outcomes in any future matter. Each case is unique and depends on its own facts and applicable law.',
    'legal.terms.p5': 'This website may contain links to third-party resources. We are not responsible for the content, accuracy, or practices of those external sites.',
    'legal.terms.p6': 'This website and all of its content are protected by copyright. Unauthorized reproduction or use is prohibited.',
    // Phone Strip
    'phone.pre': 'Free Case Evaluation —',
    'phone.post': '— Available 24/7'
  },
  es: {
    // Nav
    'nav.about': 'Nosotros',
    'nav.practice': 'Áreas de Práctica',
    'nav.results': 'Resultados',
    'nav.cta': 'Consulta Gratis',
    // Splash
    'splash.loading': 'CARGANDO REPRESENTACIÓN DE ÉLITE',
    // Hero
    'hero.badge': 'Aceptando Nuevos Clientes · Florida',
    'hero.tagline': 'Elias Navarro Law',
    'hero.headline.1': 'No Dejes Que Las',
    'hero.headline.2': 'Aseguradoras Controlen',
    'hero.headline.3': 'Tu Futuro.',
    'hero.subheadline': 'Representación legal de lujo para casos graves de accidentes y lesiones en toda Florida. Creado para obtener resultados de alto nivel.',
    'hero.btn.primary': 'Revisión Gratuita De Tu Caso',
    'hero.btn.secondary': 'Habla Con Elias Ahora',
    'hero.scroll': 'Desplazar',
    // Hero Form
    'hero.form.label': 'Revisión Gratuita · Confidencial',
    'hero.form.name': 'Nombre Completo',
    'hero.form.phone': 'Número De Teléfono',
    'hero.form.case': 'Tipo De Caso',
    'hero.form.case.placeholder': 'Selecciona tu caso',
    'hero.form.case.auto': 'Accidente De Auto',
    'hero.form.case.truck': 'Accidente De Camión',
    'hero.form.case.slip': 'Resbalón y Caída',
    'hero.form.case.motorcycle': 'Accidente De Motocicleta',
    'hero.form.case.other': 'Otra Lesión',
    'hero.form.submit': 'Recibir Mi Revisión Gratis',
    'hero.form.submitting': 'Enviando...',
    'hero.form.disclaimer': 'Sin honorarios si no ganamos · 100% confidencial · 24/7',
    'hero.form.success.title': 'Solicitud recibida.',
    'hero.form.success.body': 'Elias revisará personalmente tu caso y te contactará dentro de la próxima hora.',
    // Trust
    'trust.recovered': 'Recuperados para Clientes',
    'trust.clients': 'Clientes Representados',
    'trust.available': 'Siempre Disponibles',
    'trust.fee': 'Sin Cargos Si No Ganamos',
    // About
    'about.label': 'Sobre La Firma',
    'about.headline': 'Construido Para<br />Casos De Alto Nivel.',
    'about.body': 'Elias Navarro Law fue creado para brindar representación legal de élite a las víctimas de accidentes que se enfrentan a poderosas compañías de seguros. Después de años trabajando junto a importantes firmas corporativas en Miami, Elias Navarro construyó una firma de abogados moderna enfocada en una estrategia agresiva y atención personal.',
    'about.list.1': 'Negociación agresiva con corporaciones de seguros',
    'about.list.2': 'Comunicación rápida y directa con tu abogado',
    'about.list.3': 'Estrategia legal personalizada para cada caso',
    'about.list.4': 'Representación premium en toda Florida',
    'about.list.5': 'Enfoque orientado a resultados para clientes modernos',
    'about.tag.years': '18',
    'about.tag.text': 'Años de Práctica de Élite',
    // Practice Areas
    'practice.label': 'Lo Que Manejamos',
    'practice.headline': 'Áreas De Práctica',
    'practice.1.title': 'Accidentes De Auto',
    'practice.1.desc': 'Máxima compensación para víctimas de colisiones. Combatimos cada disputa de seguros de frente.',
    'practice.2.title': 'Accidentes De Camión',
    'practice.2.desc': 'Reclamos de alto valor contra transportistas comerciales y sus poderosos equipos legales.',
    'practice.3.title': 'Muerte Injusta',
    'practice.3.desc': 'Representación compasiva y agresiva para familias que merecen justicia y cierre.',
    'practice.4.title': 'Resbalones y Caídas',
    'practice.4.desc': 'Casos de responsabilidad de locales manejados con precisión, velocidad y defensa implacable.',
    'practice.5.title': 'Accidentes De Motocicleta',
    'practice.5.desc': 'Los motociclistas merecen protección legal de élite. Sabemos cómo ganar estos casos.',
    'practice.6.title': 'Disputas De Seguros',
    'practice.6.desc': 'No nos conformamos con ofertas bajas. Obligamos a las compañías de seguros a pagar lo que mereces.',
    'practice.learnMore': 'Saber Más →',
    // Video
    'video.label': 'Nuestro Enfoque',
    'video.headline': 'Representación Legal Moderna.',
    'video.body': 'Mira cómo Elias Navarro Law lucha por las víctimas de lesiones en toda Florida, y por qué nuestro enfoque produce resultados que otras firmas no pueden igualar.',
    'video.tag': 'Elias Navarro Law · Historias de Clientes',
    // Testimonials
    'test.label': 'Resultados De Clientes',
    'test.headline': 'Lo Que Dicen Nuestros Clientes.',
    'test.1.quote': 'Trataron mi caso como si realmente importara. La comunicación y el profesionalismo fueron de otro nivel. Nunca me he sentido más representado.',
    'test.1.author': 'M. Rivera · Accidente de Auto · Miami, FL',
    'test.2.quote': 'Casi acepto la primera oferta de la compañía de seguros. Elias Navarro Law cambió todo. Llegamos a un acuerdo por 8 veces la cantidad original.',
    'test.2.author': 'J. Delgado · Accidente de Camión · Orlando, FL',
    'test.3.quote': 'Respuestas rápidas. Representación seria. Resultado increíble. Si estás herido y necesitas un abogado de verdad, esta es la única llamada que necesitas hacer.',
    'test.3.author': 'A. Morales · Resbalón y Caída · Tampa, FL',
    // Final CTA
    'cta.label': 'Da El Primer Paso',
    'cta.headline': 'Tu caso merece más.',
    'cta.subheadline': 'Habla directamente con Elias Navarro hoy.<br />Sin presión. Sin honorarios a menos que ganemos. Solo estrategia legal de élite.',
    'cta.btn.primary': 'Inicia Tu Reclamo',
    'cta.btn.secondary': 'Consulta Gratis',
    // Footer
    'footer.copy': '© 2025 Elias Navarro Law. Todos Los Derechos Reservados.',
    'footer.disclaimer': 'Publicidad de Abogados. Los resultados anteriores no garantizan resultados similares. Este sitio web es solo para fines informativos y no constituye asesoramiento legal.',
    'footer.privacy': 'Privacidad',
    'footer.terms': 'Términos',
    'footer.contact': 'Contacto',
    // Legal Modals
    'legal.privacy.title': 'Política de Privacidad',
    'legal.privacy.p1': 'Elias Navarro Law respeta tu privacidad y se compromete a proteger tu información personal. Esta política explica qué información recopilamos, cómo la utilizamos y las opciones que tienes.',
    'legal.privacy.p2': 'Recopilamos la información que proporcionas directamente al contactarnos para una consulta, incluyendo tu nombre, número de teléfono, correo electrónico y detalles sobre tu caso. Esta información se utiliza únicamente para evaluar y responder a tu consulta.',
    'legal.privacy.p3': 'No vendemos, alquilamos ni compartimos tu información personal con terceros con fines de marketing. La información puede ser compartida con nuestro personal, expertos contratados o co-asesores legales únicamente cuando sea necesario para evaluar o gestionar tu caso.',
    'legal.privacy.p4': 'Nuestro sitio web puede utilizar cookies y herramientas de análisis para comprender cómo los visitantes interactúan con nuestro sitio. Puedes deshabilitar las cookies en la configuración de tu navegador en cualquier momento.',
    'legal.privacy.p5': 'Puedes solicitar acceso, corrección o eliminación de tu información personal en cualquier momento contactando a nuestra oficina. Conservamos los registros de consulta solo durante el tiempo legalmente necesario.',
    'legal.terms.title': 'Términos de Uso',
    'legal.terms.p1': 'Al acceder o utilizar este sitio web, aceptas estos Términos de Uso. Si no estás de acuerdo, por favor no utilices el sitio.',
    'legal.terms.p2': 'El contenido de este sitio web es solo para fines informativos generales y no constituye asesoramiento legal. No se crea ninguna relación abogado-cliente por visitar este sitio, enviar un formulario de contacto o enviar un correo electrónico.',
    'legal.terms.p3': 'Una relación abogado-cliente se forma únicamente con la firma de un acuerdo de representación escrito entre Elias Navarro Law y el cliente.',
    'legal.terms.p4': 'Los resultados de casos anteriores, acuerdos y veredictos mencionados en este sitio no garantizan ni predicen resultados similares en cualquier asunto futuro. Cada caso es único y depende de sus propios hechos y leyes aplicables.',
    'legal.terms.p5': 'Este sitio web puede contener enlaces a recursos de terceros. No somos responsables del contenido, la precisión o las prácticas de esos sitios externos.',
    'legal.terms.p6': 'Este sitio web y todo su contenido están protegidos por derechos de autor. La reproducción o uso no autorizado está prohibido.',
    // Phone Strip
    'phone.pre': 'Evaluación Gratuita De Caso —',
    'phone.post': '— Disponible 24/7'
  }
};
export type TranslationKey = keyof typeof translations.en;
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: TranslationKey) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>('es');
  useEffect(() => {
    const savedLang = localStorage.getItem('elias_navarro_lang') as Lang;
    if (savedLang && (savedLang === 'en' || savedLang === 'es')) {
      setLangState(savedLang);
    }
  }, []);
  const setLang = (newLang: Lang) => {
    setLangState(newLang);
    localStorage.setItem('elias_navarro_lang', newLang);
  };
  const t = (key: TranslationKey): string => {
    return translations[lang][key] || translations['en'][key] || key;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-162">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}